import analyticEvents from "../utils/constants/analyticEvents";

declare global {
  interface Window {
    Intercom: any;
  }
}

const track = (eventName: string, metadata: any) => {
  const events = Object.values(analyticEvents);
  if (events.includes(eventName) && !!window.Intercom) {
    window.Intercom("trackEvent", eventName, metadata);
  }
};

const hideMessenger = (value: any) => {
  window.Intercom("update", {
    hide_default_launcher: value,
  });
};

const showNewMessage = (prePopulatedMessage: any) => {
  window.Intercom("showNewMessage", prePopulatedMessage);
};

export default { track, hideMessenger, showNewMessage };
